import { Pipe, PipeTransform } from '@angular/core';

import { formatBalanceByCurrency } from '@kr/models';

@Pipe({
  name: 'balanceFormat',
  standalone: true,
})
export class CurrencyBalanceFormatPipe implements PipeTransform {
  /**
   * Transforms a string value to a formatted number string based on the currency type.
   *
   * @param {string} value - The string representation of the value to be formatted.
   * @param {string} symbol - The currency symbol (e.g., 'USDT', 'BTC', etc.).
   * @returns {string} - The formatted number string:
   *  - USDT is formatted to 2 decimal places
   *  - TRX is formatted to 7 decimal places
   *  - Other cryptocurrencies are formatted to 8 decimal places
   *  - If the value is empty, returns the corresponding zero format
   */
  transform(value: string, symbol?: string): string {
    return formatBalanceByCurrency(value, symbol);
  }
}
